import axios from 'axios';
import { PublicClientApplication } from '@azure/msal-browser';
import { loginRequest, msalConfig } from '../authConfig';
import configData from '../config.json';

const msalInstance = new PublicClientApplication(msalConfig);

export const API_URL = `${configData.REACT_APP_BACKEND_URL}/api`;

function refreshAccessToken() {
  return msalInstance.acquireTokenSilent({
    scopes: loginRequest.scopes,
    account: {}
  });
}

const axiosClient = axios.create({
  baseURL: API_URL,
  withCredentials: true
});

axiosClient.interceptors.request.use(
  (config) => {
    const AirswiftAccessToken = localStorage.getItem('AirswiftAccessToken');
    if (AirswiftAccessToken) {
      config.headers['Authorization'] = `Bearer ${AirswiftAccessToken}`;
    }

    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    config.headers['Access-Control-Allow-Origin'] = '*';
    config.headers['Access-Control-Allow-Credentials'] = 'true';
    config.headers['Access-Control-Allow-Methods'] = 'GET,PUT,PATCH,POST,DELETE,HEAD,OPTIONS';
    return config;
  },
  (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401) {
      return refreshAccessToken()
        .then(({ accessToken }) => {
          localStorage.setItem('AirswiftAccessToken', accessToken);
          originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
          // eslint-disable-next-line no-underscore-dangle
          originalRequest._retry = true;

          return axios(originalRequest);
        })
        .catch((err) => {
          msalInstance
            .loginRedirect({ ...loginRequest, state: JSON.stringify({ navigate: window.location.pathname }) })
            .catch((e) => {
              console.error(e);
            });
          return Promise.reject(err);
        });
    }
    if (error.response && error.response.status === 403) {
      error.response.data = JSON.parse('{"error": "Sorry. Not enough permissions."}');
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
